import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DropdownItemModule } from './../../common/dropdown/dropdown-item/dropdown-item.module';
import { DropdownModule } from './../../common/dropdown/dropdown.module';
import { SpinnerModule } from './../../common/spinner/spinner.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { TypeaheadInlineComponent } from './typeahead-inline.component';
import { TypeaheadInputDirective } from './typeahead-input.directive';
import { TypeaheadSuggestionsComponent } from './typeahead-suggestions.component';
import { TypeaheadComponent } from './typeahead.component';

@NgModule({
  declarations: [
    TypeaheadComponent,
    TypeaheadInlineComponent,
    TypeaheadInputDirective,
    TypeaheadSuggestionsComponent,
  ],
  exports: [
    TypeaheadComponent,
    TypeaheadInlineComponent,
    TypeaheadInputDirective,
    TypeaheadSuggestionsComponent,
  ],
  imports: [RtUICoreOverlayModule, CommonModule, DropdownItemModule, SpinnerModule, DropdownModule],
})
export class TypeaheadModule {}

export {
  TypeaheadInlineComponent,
  TypeaheadComponent,
  TypeaheadInputDirective,
  TypeaheadSuggestionsComponent,
};
